export const arraySetFieldValueNaturalPersonBusiness = [
  { key: 'businessName', value: '' },
  { key: 'identificationType', value: '' }
];

export const arraySetFieldValueJuridicalPersonBusiness = [
  { key: 'lastName', value: '' },
  { key: 'identificationType', value: '31' }
];

export const arraySetFieldValueNaturalPersonPayments = [
  { key: 'paymentBusinessName', value: '' },
  { key: 'paymentIdentificationType', value: '' }
];

export const arraySetFieldValueJuridicalPersonPayments = [
  { key: 'paymentLastName', value: '' },
  { key: 'paymentIdentificationType', value: '31' }
];
